import { option } from 'fp-ts';
import { pipe } from 'fp-ts/function';

import { filter } from 'lodash/fp';
import { convertToMultiCurrencyAmount, createZeroAmount, MultiCurrencyAmount } from '@mews-distributor/common';
import { values } from '@mews/fp';
import { composeProps, createPropsExtender } from '@mews/framework/redux';

import { getCurrentDateEnterpriseAvailability } from '../../../selectors/availability';
import { ApplicationState } from '../../../types';
import { Category } from '../../../types/data';
import { WithEnterpriseId } from '../../../types/selectors/selectorPropTypes';
import { getCurrencyCode } from '../../app/selectors';
import { getEnterprisePricingModeKey } from '../../entities/enterprises/selectors';
import { getEnterpriseServiceId } from '../../entities/services/selectors';
import { getSelectedHotelId } from '../../resourceOrder/selectors';
import { getCurrentDateServiceLowestPrice } from './servicePricing';

const filterAvailableCategories = filter<Category>(({ availableCount }) => availableCount > 0);

export const getCurrentDateEnterpriseLowestPrice = (
    state: ApplicationState,
    { enterpriseId }: WithEnterpriseId
): MultiCurrencyAmount | null => {
    const pricingModeKey = getEnterprisePricingModeKey(state, { enterpriseId });
    const currencyCode = getCurrencyCode(state);

    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (currencyCode == null || !pricingModeKey) {
        return null;
    }

    const availability = getCurrentDateEnterpriseAvailability(state, { enterpriseId });
    const categories = pipe(availability.categories ?? {}, values, filterAvailableCategories);

    const categoryIds = categories.map((category) => category.id);

    return pipe(
        getEnterpriseServiceId(state, { enterpriseId }),
        option.fromNullable,
        option.flatMap((serviceId) =>
            getCurrentDateServiceLowestPrice(state, {
                currencyCode,
                serviceId,
                categoryIds,
            })
        ),
        option.map(convertToMultiCurrencyAmount),
        option.getOrElse(() => convertToMultiCurrencyAmount(createZeroAmount(currencyCode)))
    );
};

export const getCurrentDateSelectedEnterpriseLowestPrice = composeProps(
    getCurrentDateEnterpriseLowestPrice,
    createPropsExtender('enterpriseId', getSelectedHotelId)
);
